import React from 'react';
import { useTradingViewWidget } from '../hooks/useTradingViewWidget';

const CONFIG = {
  feedMode: 'all_symbols',
  isTransparent: true,
  displayMode: 'compact',
  width: '100%',
  height: 400,
  colorTheme: 'dark',
  locale: 'en'
};

const TradingViewNews = () => {
  const containerRef = useTradingViewWidget(
    'https://s3.tradingview.com/external-embedding/embed-widget-timeline.js',
    CONFIG
  );

  return (
    <div
      className="tradingview-widget-container"
      ref={containerRef}
      data-testid="market-news-widget"
      style={{ height: '400px', width: '100%' }}
    />
  );
};

export default TradingViewNews;
